import React, { useContext } from 'react';
import {
  ELSPropsFromModalService,
  ELSWithModalService
} from '@els/els-component-modal-react';
import { flowRight } from 'lodash';

import AiChatBaseTemplate from '../../components/ai-chat-base-template/AiChatBaseTemplate.component';
import { AppContext } from '../../components/app/AppProvider.component';
import {
  buildEbookSsoUrlRequestFromIsbn,
  getBookTitleWithEdition,
  getBrandName,
  getIsDirectAccessByFeatureFlag,
  getOrderedPurchasedEntitlements,
  openBookFilterModal
} from '../ai-chat/ai-chat.utilities';
import withHTMLHeadSEO from '../../hocs/with-html-head-seo/withHTMLHeadSEO.hoc';
import { FlexLayout } from '../../components/flex/FlexLayout.component';
import { FlexLayoutModifier } from '../../components/flex/flex.constants';
import { FlexItem } from '../../components/flex/FlexItem.component';
import { fetchEbookSsoUrlAction } from '../../components/app/app-state-actions.utilities';
import { RecordEmpty } from '../../models/common.models';
import {
  getTokenIsbnsArray
} from '../../components/app/app-state.utilities';

export type YourBooksProps = ELSPropsFromModalService;

const YourBooksComponent = (props: YourBooksProps) => {

  const {
    appState,
    setAppState,
    appStateRef
  } = useContext(AppContext);

  const entitlements = getOrderedPurchasedEntitlements(appState.entitlements);
  const isDirectAccessByFeatureFlag = getIsDirectAccessByFeatureFlag(
    appState.featureFlagsGrouped,
    appState.courseSectionId,
    getTokenIsbnsArray()
  );
  return (
    <AiChatBaseTemplate
      isPanelOpen={false}
      panelContent={null}
    >
      <div className="c-naa-base-page">
        <div className="c-naa-base-page__header">
          <div className="c-naa-base-page__inner">
            <h3>Your books</h3>
          </div>
        </div>
        <div className="c-naa-base-page__body">
          <div className="c-naa-base-page__inner">

            <div className="u-els-margin-bottom-3x">
              <FlexLayout modifiers={[FlexLayoutModifier.GUTTERS_2X]}>
                <FlexItem modifiers={[FlexLayoutModifier.GROW]}>
                  Your eBook entitlements available to {getBrandName(appState)}.
                </FlexItem>
                <FlexItem>
                  {
                    !isDirectAccessByFeatureFlag
                    && entitlements
                    && entitlements.length > 1
                    && (
                      <FlexItem>
                        <button
                          type="button"
                          className="c-els-button c-els-button--small c-els-button--secondary c-els-ai-chat__choose-book-btn"
                          id="bookFiltersBtn"
                          onClick={() => {
                            openBookFilterModal({ appStateRef, modalService: props.modalService })
                          }}
                        >
                          Filter your conversation by book
                        </button>
                      </FlexItem>
                    )
                  }
                </FlexItem>
              </FlexLayout>
            </div>

            <div>

              {entitlements
                .map(({ isbn, title, author, edition }) => {
                  if (!title) {
                    return null;
                  }

                  const bookTitleWithEdition = getBookTitleWithEdition(title, edition);

                  return (
                    <FlexLayout key={isbn}
                      modifiers={[FlexLayoutModifier.GUTTERS_2X]}
                      classes={['c-naa-your-books__item']}
                    >
                      <FlexItem modifiers={[FlexLayoutModifier.GROW]} classes={['c-naa-your-books__user-materials-title-parent']}>
                        <button
                          title={bookTitleWithEdition}
                          type="button"
                          role="link"
                          className="u-els-anchorize u-els-debuttonize c-naa-your-books__user-materials-title"
                          onClick={() => {
                            const request = buildEbookSsoUrlRequestFromIsbn(appState, isbn);

                            fetchEbookSsoUrlAction({
                              appState,
                              appStateRef,
                              setAppState,
                              request
                            }).then((response) => {
                              window.open(response.signInUrl, '_blank');
                            });
                          }}
                        >
                          {bookTitleWithEdition}
                        </button>
                        <div className="c-naa-your-books__user-materials-author"><small>{author}</small></div>
                      </FlexItem>
                      <FlexItem>
                        <span className="u-els-color-n7">{appState.messages.SHERPATH_AI_EBOOK_LABEL}</span>
                      </FlexItem>
                    </FlexLayout>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
    </AiChatBaseTemplate>
  );
};

const enhance = flowRight(
  ELSWithModalService,
  withHTMLHeadSEO({ title: 'Your books' }),
);

const YourBooks: React.FC<RecordEmpty> = enhance(YourBooksComponent);

export default YourBooks;
